import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 35,
	height: 36,
	viewBox: "0 0 35 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5002 27.9266C17.2328 27.9266 17.0151 27.7089 17.0151 27.4398V1.21295C17.0151 0.945589 17.2328 0.72794 17.5002 0.72794C17.7675 0.72794 17.985 0.945589 17.985 1.21295V27.4398C17.985 27.7089 17.7675 27.9266 17.5002 27.9266Z",
			fill: "#272525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.515 35.4418H0.48503C0.217671 35.4418 0 35.2241 0 34.955V17.8766C0 17.6076 0.217671 17.3916 0.48503 17.3916C0.755817 17.3916 0.973408 17.6076 0.973408 17.8766V34.47H34.0299V17.8766C34.0299 17.6076 34.2459 17.3916 34.515 17.3916C34.7823 17.3916 35 17.6076 35 17.8766V34.955C35 35.2241 34.7823 35.4418 34.515 35.4418Z",
			fill: "#272525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1024 6.01172L20.7066 5.8095L17.5 1.31067L14.2951 5.8095C14.1391 6.02544 13.8357 6.07686 13.6181 5.92262C13.3987 5.76666 13.3473 5.46158 13.5033 5.24392L17.1057 0.191524C17.2874 -0.0638385 17.7142 -0.0638385 17.8958 0.191524L21.4966 5.24392C21.6525 5.46158 21.6028 5.76666 21.3834 5.92262L21.1024 6.01172Z",
			fill: "#272525"
		})
	]
});
export { SvgUpload as ReactComponent };
